var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgermenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 42,
    viewBox: "0 0 52 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.759 2.3111C52.398 1.0017 51.8868 0.689199 48.7556 0.64456C45.273 0.599922 41.7903 0.599927 37.5409 0.570168L35.9437 0.542041L12.4996 0.16843C10.455 0.144571 8.4144 0.115077 6.38903 0.0642878C-0.672073 -0.114267 -0.672035 -0.129148 0.733791 2.92116C3.41766 8.72417 16.1979 12.8309 29.074 12.0126C39.5219 11.343 49.3946 7.13207 51.759 2.3111Z",
    fill: "#18466F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.759 17.3606C52.398 16.1057 51.8868 15.8062 48.7556 15.7635C45.273 15.7207 41.7903 15.7207 37.5409 15.6922L35.9437 15.6652L12.4996 15.3072C10.455 15.2843 8.4144 15.256 6.38903 15.2074C-0.672073 15.0362 -0.672035 15.022 0.733791 17.9452C3.41766 23.5064 16.1979 27.4421 29.074 26.6578C39.5219 26.0161 49.3946 21.9806 51.759 17.3606Z",
    fill: "#18466F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.759 32.0975C52.398 30.7881 51.8868 30.4756 48.7556 30.4309C45.273 30.3863 41.7903 30.3863 37.5409 30.3565L35.9437 30.3284L12.4996 29.9548C10.455 29.9309 8.4144 29.9015 6.38903 29.8507C-0.672073 29.6721 -0.672035 29.6572 0.733791 32.7075C3.41766 38.5105 16.1979 42.6173 29.074 41.7989C39.5219 41.1294 49.3946 36.9184 51.759 32.0975Z",
    fill: "#18466F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgermenu);
export default __webpack_public_path__ + "static/media/burgermenu.51ae6d0e18ba99c21fdb9a9f2aa3401e.svg";
export { ForwardRef as ReactComponent };